export default {
  isAuthenticated: false,
  me: {},
  branches:[]
}
